const API_URL = process.env.REACT_APP_API_URL

// Helper function to get admin token from localStorage
export const getAdminToken = (): string | null => {
  return localStorage.getItem('adminToken')
}

// Helper function to create headers with authorization token
export const createAuthHeaders = (): HeadersInit => {
  const token = getAdminToken()
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  }
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  
  return headers
}

// Define the login credentials interface
interface LoginCredentials {
  email: string
  password: string
}

// Define the OTP verification payload interface
interface OTPVerificationPayload {
  email: string
  otp: string
}

// Function to initiate admin login (OTP disabled - direct login)
export const loginAdmin = async (credentials: LoginCredentials) => {
  try {
    const response = await fetch(`${API_URL}/admin/login/initiate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    })

    const data = await response.json()

    if (response.ok) {
      if (data.otpRequired) {
        return {
          success: true,
          otpRequired: true,
          message: data.message,
        }
      }
      // Direct login - return user and token
      return {
        success: true,
        message: data.message,
        user: data.user,
        token: data.token,
      }
    } else {
      return {
        success: false,
        message: data.message || 'Login failed',
      }
    }
  } catch (error) {
    console.error('Error trying to login', error)
    throw new Error('An error occurred during login')
  }
}

// Function to verify OTP and complete login
export const verifyOTP = async (payload: OTPVerificationPayload) => {
  try {
    const response = await fetch(`${API_URL}/admin/login/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    const data = await response.json()

    if (response.ok) {
      // Return the response data, including user info and token
      return {
        success: true,
        message: data.message,
        user: data.user,
        token: data.token,
      }
    } else {
      // Return a structured response indicating failure
      return {
        success: false,
        message: data.message || 'OTP verification failed',
      }
    }
  } catch (error) {
    console.error('Error verifying OTP', error)
    throw new Error('An error occurred during OTP verification')
  }
}
